export default {
  name: 'RgSuggestMixin',
  props: {
    label: {
      default: 'Sugestões'
    },
    placeholder: {
      default: 'Digite a sugestão'
    },
    value: {
      default: null
    },
    rules: {
      default: null
    }
  },
  data () {
    return {
      selectedItemIdx: 0,
      exhibitionText: '',
      inputValue: '',
      suggestionList: [],
      isSearching: false,
      isNotFound: false
    }
  },
  computed: {
    showSearch () {
      const shouldShowSearch = this.suggestionList && this.suggestionList.length > 0
      return shouldShowSearch
    }
  },
  watch: {
    inputValue (pValue) {
      this.$emit('input', pValue)
    },
    value: {
      handler (pValue) {
        this.inputValue = pValue
      },
      immediate: true
    }
  },
  methods: {
    async search (pSearch) {
      this.selectedItemIdx = 0
      this.isSearching = true
      this.isNotFound = false
      try {
        const res = await this.doSearch(pSearch)
        this.suggestionList = res
        if (res && res.length === 0) {
          this.isNotFound = true
        } else {
          this.isNotFound = false
        }
      } catch (error) {
        this.isNotFound = true
      } finally {
        this.isSearching = false
      }
    },
    createOutput (pItem) {
      const emitOutput = {
        textRaw: this.inputValue,
        source: pItem
      }
      return emitOutput
    },
    selectingItemFromSuggestList (pItem) {
      this.inputValue = pItem[this.captionRaw]
      const outputFormated = this.createOutput(pItem)
      this.suggestionList = []
      this.$emit('selected', outputFormated)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/primitives/input-suggest/InputSuggestMixin.js